var map = {
	"./": 99003,
	"./ca": 66975,
	"./ca.js": 66975,
	"./cn": 83350,
	"./cn.js": 83350,
	"./en": 48176,
	"./en.js": 48176,
	"./es": 53883,
	"./es.js": 53883,
	"./fi": 76298,
	"./fi.js": 76298,
	"./formatted-message": 17117,
	"./formatted-message.js": 17117,
	"./index": 99003,
	"./index.js": 99003,
	"./ja": 70518,
	"./ja.js": 70518,
	"./locales": 6144,
	"./locales.js": 6144,
	"./pt": 23347,
	"./pt.js": 23347,
	"./ru": 98946,
	"./ru.js": 98946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86718;